function collectionItemsInit() {
  const collectionItems = document.querySelectorAll('[data-collection-item]');
  if (!collectionItems) { return; }
  collectionItems.forEach(item => {
    collectionItemInit(item);
  });
}

 function collectionItemInit(item) {
  const helpOpen = item.querySelector('[data-collection-item-help-toggle]');
  const helpClose = item.querySelector('[data-collection-item-help-close]');

  if (!helpOpen || !helpClose) { return; }

  helpOpen.addEventListener('click', () => {
    item.classList.add('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });

  helpClose.addEventListener('click', () => {
    item.classList.remove('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  collectionItemsInit();
});

// collection item popup


function initPopups() {
  const popups = document.querySelectorAll('[collection-item-popup]');
  const openButtons = document.querySelectorAll('[data-open-collection-item-popup]');
  const closeButtons = document.querySelectorAll('[data-close-collection-item-popup]');
  let activePopup = null;

  popups.forEach((popup) => {
    internalPopupSetup(popup);
  });

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetString = button.getAttribute('data-open-collection-item-popup');
      if (!targetString) { return; }
      openPopup(targetString);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      closePopups();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || activePopup === null) { return; }
    closePopups();
  });

  function openPopup(targetString) {
    const targetPopup = document.querySelector(`[collection-item-popup--${targetString}]`);
    if (!targetPopup) { return; }
    hideElements(popups);
    targetPopup.classList.remove('hide');
    activePopup = targetPopup;
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';
    trapFocus(targetPopup);
  }

  function closePopups() {
    document.body.style.overflow = null;
    document.body.style.height = null;
    hideElements(popups);
    activePopup.querySelector('[data-details]').classList.remove('hide');
    activePopup.querySelector('[data-gallery]').classList.add('hide');
    removeTrapFocus(activePopup);
    activePopup = null;
  }

  function hideElements(elements) {
    elements.forEach((element) => {
      element.classList.add('hide');
    });
  }
}

function internalPopupSetup(popup) {
  const details = popup.querySelector('[data-details]');
  const gallery = popup.querySelector('[data-gallery]');
  const descThumbs = popup.querySelectorAll('[data-description-thumb]');
  const descBack = popup.querySelectorAll('[data-description-back]');

  descThumbs.forEach((button) => {
    button.addEventListener('click', () => {
      details.classList.add('hide');
      gallery.classList.remove('hide');
      sliderInit();
    });
  });

  descBack.forEach((button) => {
    button.addEventListener('click', () => {
      details.classList.remove('hide');
      gallery.classList.add('hide');
    });
  });

  function sliderInit() {
    const gallerySlider = popup.querySelector('[data-gallery-slider]');
    if (!gallerySlider || gallerySlider.getAttribute('data-slide-init') !== null) { return; }
    const thumbSlider = popup.querySelector('[data-gallery-thumb-slider]');

    const galleryThumbs = new Swiper(thumbSlider, {
      slidesPerView: 'auto',
      speed: 1000,
      freeMode: false,
      loop: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true,
        eventsTarget: thumbSlider.querySelector('[data-wrapper-thumb]'),
        invert: true,
      },
      navigation: {
        nextEl: popup.querySelector('[data-next]'),
        prevEl: popup.querySelector('[data-prev]'),
      },
    });

    new Swiper(gallerySlider, {
      slidesPerView: 1,
      speed: 1000,
      freeMode: false,
      loop: true,
      disableOnInteraction: false,
      mousewheel: {
        forceToAxis: true,
        eventsTarget: gallerySlider.querySelector('[data-wrapper]'),
        invert: true,
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });

    gallerySlider.setAttribute('data-slide-init', 'true');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initPopups();
});

// process steps

function faqs() {
  const questions = document.querySelectorAll('[data-process-steps-question]');
  const answers = document.querySelectorAll('[data-process-steps-answer]');

  if (!questions || !answers) { return; }

  questions.forEach((question) => {
    question.addEventListener('click', () => {
      const details = question.getAttribute('data-process-steps-question');
      const detailsSplit  = details.split('-faq-');
      const expanded = question.getAttribute('aria-expanded');
      const step = detailsSplit[0];

      if (!question.classList.contains('active')) {
        document.querySelectorAll(`[data-process-steps-question^="${step}"]`).forEach((que) => {
          que.classList.remove('active');
          que.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll(`[data-process-steps-answer^="${step}"]`).forEach((ans) => {
          ans.classList.remove('active');
        });
      }

      if (expanded === 'false') {
        question.setAttribute('aria-expanded', 'true');
      } else {
        question.setAttribute('aria-expanded', 'false');
      }

      document.querySelector(`[data-process-steps-answer="${details}"]`).classList.toggle('active');
      question.classList.toggle('active');
    });
  });
}

// Ensure images stay in place when section grows/shrinks
function centerImages() {
  const steps = document.querySelectorAll('[data-process-step]');
  const images = document.querySelectorAll('[data-process-step-image]');

  if (!steps) { return; }

  checkViewport();

  window.addEventListener('resize', () => {
    checkViewport();
  });

  function checkViewport() {
    const breakpoint = window.matchMedia('(min-width: 749px)');

    if (breakpoint.matches) {
      calculatePosition();
    } else {
      images.forEach((image) => {
        image.classList.remove('step-image-center');
        image.style.top = 'initial';
      });
    }
  }

  function calculatePosition() {
    steps.forEach((step) => {
      const image = step.querySelector('[data-process-step-image]');
      const imageHeight = image.clientHeight;
      const stepHeight = step.clientHeight;

      if (stepHeight >= imageHeight && step.querySelectorAll('[data-process-steps-question]').length > 0) {
        image.classList.add('step-image-center');
        image.style.top = `calc((${stepHeight}px - ${imageHeight}px) / 2)`;
      } else {
        image.classList.remove('step-image-center');
        image.style.top = 'initial';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  faqs();
  centerImages();
});
